import request from '@/axios'


export function fetchField (payload) {
  return request({
    url:'column/fetch_column',
    method: 'POST',
    data: payload
  })
}

export function arrangeColumn (payload) {
  return request({
    url : 'column/arrange_column',
    method : 'POST',
    data : payload
  })
}

